import { render, staticRenderFns } from "./card-preview.vue?vue&type=template&id=44cdaffc&scoped=true&"
import script from "./card-preview.vue?vue&type=script&lang=js&"
export * from "./card-preview.vue?vue&type=script&lang=js&"
import style0 from "./card-preview.vue?vue&type=style&index=0&id=44cdaffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cdaffc",
  null
  
)

export default component.exports